<template>
    <div id="customerContainer">
        <p>重要客户及合作单位</p>
        <div id="customerWapper">
            <div id="custLeft" class="custImg"></div>
            <div id="customerCont"></div>
            <div id="custRight" class="custImg"></div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Screen5',
}
</script>

<style scoped>
    #customerContainer{
        padding: 50px 0;
        position: relative;
    }
    #customerContainer>p{
        text-align: center;
        font-size: 18px;
    }
    #customerWapper{
        overflow: hidden;
    }
    #customerCont{
        width: 1120px;
        height: 300px;
        margin: 0 auto;
        margin-top: 60px; 
        background: url(../../assets/imgs/case/cust1.png);
        background-size: 100% 100%;
    }
    .custImg{
        width: calc((100% - 1120px)/2);
        position: absolute;
        top: 50px;
        height: 380px;
    }
    #custLeft{
        float: left;
        background-image: url(../../assets/imgs/case/cust2.png); /* 什么图片都可以*/
        -webkit-animation: scrollToUp 5s linear infinite; /* 引入 scrollToUp动画 */
        animation: scrollToUp 5s linear infinite;
        background-size: 100%;
        left: 0;
    }
    #custRight{
        background-image: url(../../assets/imgs/case/cust2.png); 
        -webkit-animation: scrollToUp 5s linear infinite; /* 引入 scrollToUp动画 */
        animation: scrollToUp 5s linear infinite;
        background-size: 100%;
        right: 0;
    }
    @-webkit-keyframes scrollToUp {
        0% {
            background-position: 0 0;
        }
        100% {
            background-position: 0 -300px;  
        }
    }
    @keyframes scrollToUp {
        0% {
            background-position: 0 0;
        }
        100% {
            background-position: 0 -300px;
        }
    }

</style>
